import { getAuthenticationList } from 'api/authApi';
import { getDefaultCrm } from 'api/advertisableApi';
import { CrmOptionType, TrayServiceType } from 'types/rofl';
import { StateCreator } from 'zustand';

// the following imports are needed for types even though they aren't used directly
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { devtools } from 'zustand/middleware';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { immer } from 'zustand/middleware/immer';


interface Scope {
    name: string;
    title: string;
    description: string;
}
export interface ITrayAuthenticatedService{
    name: TrayServiceType;
    title: string;
    missing_scopes: Scope[];
}
export interface AuthSlice {
    destination: string;
    updateDestination: (destination: string) => void;

    crm: CrmOptionType | undefined;
    updateCrm: (advertisableEid?: string) => Promise<void>;
    loadingCrm: boolean;

    authentications: Record<TrayServiceType, ITrayAuthenticatedService>;
    updateAuthentications: (advertisableEid?: string) => Promise<void>;
    loadingAuth: boolean;
}

export const createAuthSlice: StateCreator<AuthSlice, [['zustand/immer', never], ['zustand/devtools', never]], [], AuthSlice> = set => ({
    /**
     * service authentications
     */
    authentications: {} as Record<TrayServiceType, ITrayAuthenticatedService>,
    updateAuthentications: async (advertisableEid?: string) => {
        if (!advertisableEid) {
            return;
        }
        set({ loadingAuth: true });
        try {
            const response = await getAuthenticationList(advertisableEid);
            const auths = (response || []).reduce((accu: any, auth: { name: any }) => ({
                ...accu,
                [auth.name]: auth,
            }), {});
            set({ authentications: auths, loadingAuth: false });
        } catch (error: any) {
            console.error(error?.message || JSON.stringify(error));
            // if error occurred when getting the auth response, then assume no credentials
            set({
                authentications: {} as Record<TrayServiceType, ITrayAuthenticatedService>,
                loadingAuth: false
            });
        }
    },
    loadingAuth: false,

    /**
     * default CRM of the system
     */
    crm: undefined,
    updateCrm: async (advertisableEid?: string) => {
        if (!advertisableEid) {
            return;
        }
        set({ loadingCrm: true });
        try {
            const crm = await getDefaultCrm(advertisableEid);
            set({ crm, loadingCrm: false });
        } catch (error: any) {
            console.error(error?.message || JSON.stringify(error));
            set({ crm: undefined, loadingCrm: false });
        }
    },
    loadingCrm: false,

    /**
     * current selected destination in the account action node, e.g. 'crm', 'email'
     */
    destination: '',
    updateDestination: (destination: string) => set({ destination }),
});
